import { AuthenticationPage } from '@apps-common/apps/my-monitoring/pages/authenticate/Index'

export const Authentication = () => <AuthenticationPage />
